import { t } from "@/i18n-js/instance";
import { QuestionCorrectStatus } from "@/react/components/Spaces/CourseSpace/Show/Lesson/Content/QuizContent/QuestionCorrectStatus";
import type { QuizAttemptQuestion } from "@/react/types/QuizAttempt";
import { Typography } from "@circle-react-uikit/Typography";
import { OptionItem } from "./OptionItem";

interface QuestionItemProps {
  question: QuizAttemptQuestion;
}
export const QuestionItem = ({ question }: QuestionItemProps) => (
  <div className="border-primary rounded-md border p-8">
    {question.cover_media && (
      <div className="bg-secondary group relative mb-5 aspect-[2.7388059701] w-full rounded-lg">
        <img
          src={question.cover_media.url}
          loading="lazy"
          alt={t("courses.edit.lesson.cover_media_alt")}
          className="h-full w-full rounded-lg"
        />
      </div>
    )}
    <Typography.LabelMd weight="semibold">
      {question.statement}
    </Typography.LabelMd>
    <QuestionCorrectStatus question={question} />
    {question.options.map(option => (
      <OptionItem
        key={option.id}
        option={option}
        questionType={question.question_type}
      />
    ))}
  </div>
);
